"use client";

import { formatFestivalDatesWithPreferences } from "@workspace/shared-utils";
import type { FestivalSearchResult } from "@workspace/types";
import { cn } from "@workspace/ui/lib/utils";
import { FestivalPoster } from "@/components/shared/photos/festival-poster";
import { useUserPreferences } from "@/hooks/shared/use-user-preferences";

export interface FestivalResultProps {
	festival: FestivalSearchResult & {
		venue_obj?: {
			id: string;
			name: string;
			slug: string;
			city: string;
			state?: string | null;
			country: string;
			venue_type?: string | null;
			capacity?: number | null;
		} | null;
	};
	isSelected: boolean;
	onSelect: () => void;
}

export function FestivalResult({
	festival,
	isSelected,
	onSelect,
}: FestivalResultProps) {
	// Get user preferences for date formatting
	const userPreferences = useUserPreferences();

	return (
		<button
			type="button"
			className={cn(
				"relative flex w-full items-center gap-3 rounded-lg p-3 text-left transition-colors",
				isSelected ? "bg-muted" : "hover:bg-muted",
			)}
			onClick={onSelect}
		>
			<FestivalPoster
				name={festival.name}
				posterUrl={festival.poster_url || null}
				size="sm"
				rounded="md"
				className="h-[53px] w-10"
			/>
			<div className="flex min-w-0 flex-1 flex-col">
				<span className="truncate font-medium text-sm">{festival.name}</span>
				<span className="truncate text-muted-foreground text-xs">
					{festival.venue_obj
						? `${festival.venue_obj.name}${festival.venue_obj.city ? ` • ${festival.venue_obj.city}` : ""}${festival.venue_obj.state ? `, ${festival.venue_obj.state}` : ""}`
						: festival.location}
				</span>
				<span className="text-muted-foreground text-xs">
					{formatFestivalDatesWithPreferences(
						festival.start_date,
						festival.end_date,
						userPreferences,
					)}
				</span>
			</div>
		</button>
	);
}
